import { useState } from "react";
import { GetPriceList } from "../api";
import DefaultCurrencyFormat from "../DefaultCurrencyFormat";
import Warning from "./Warning";
import Modal from "../Modal";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useTranslation } from "../../context/TranslationContext";

const ServiceRow = ({
  service,
  symbol,
  isOptional,
  isSelected,
  onServiceChange,
  AvailableExtraServices,
}) => {
  const {
    nightLabel,
    moreInfo,
    free,
    dateLabel,
    amountLabel,
    statusLabel,
    statusAvailable,
    statusUnavailable,
    serviceFreePre,
    serviceFreeStrong,
    serviceFreePost,
    servicePaidPre,
    servicePaidPost,
  } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);
  const value =
    Number(service.amount) * (service.Type === "1" ? 1 : service.totalDays);

  const availableDates = AvailableExtraServices?.map((serviceItem) => {
    const findService = serviceItem.extraServices.find(
      (s) => s.id === service.id,
    );
    return {
      date: serviceItem.date,
      price: findService?.amount,
      status: findService ? 1 : 0,
    };
  });

  return (
    <div className="flex flex-col w-full text-13">
      <div
        className="flex gap-4 justify-between items-start w-full cursor-pointer"
        onClick={(e) => {
          if (isOptional) {
            e.preventDefault();
            onServiceChange(service.id);
          }
        }}
      >
        <div className="flex flex-col flex-grow">
          <span className="font-medium opacity-80 mb-0.5">{service.title}</span>
          <span className="text-xs opacity-60">
            {service.totalDays} {nightLabel} {GetPriceList} -{" "}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowDetails(!showDetails);
              }}
              type="button"
              className="underline outline-none hover:text-orange transition-colors"
            >
              {moreInfo}
            </button>
          </span>
        </div>

        <div className="flex flex-col items-end gap-1 shrink-0 mt-0.5">
          <span className="font-bold whitespace-nowrap">
            {service.amount === "0" ? (
              <span className="font-bold opacity-60">{free}</span>
            ) : (
              <DefaultCurrencyFormat Symbol={symbol} value={value} />
            )}
          </span>
          {isOptional && (
            <button
              type="button"
              className={`relative inline-flex h-4 w-7 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                isSelected ? "bg-orange" : "bg-gray-300"
              }`}
              role="switch"
              aria-checked={isSelected}
            >
              <span
                className={`pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                  isSelected ? "translate-x-3" : "translate-x-0"
                }`}
              />
            </button>
          )}
        </div>
      </div>

      <Modal isOpen={showDetails} closeModal={() => setShowDetails(false)}>
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-xl rounded-lg bg-white p-6 shadow-lg max-h-full my-2 overflow-y-auto relative">
            <button
              onClick={() => setShowDetails(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              X
            </button>
            <Dialog.Title className="text-lg font-medium text-gray-900">
              {service.title}
            </Dialog.Title>
            <div className="mt-4">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead>
                    <tr className="bg-gray-50">
                      <th
                        scope="col"
                        className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {dateLabel}
                      </th>
                      {service.Type == "0" && (
                        <th
                          scope="col"
                          className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
                        >
                          {amountLabel}
                        </th>
                      )}
                      <th
                        scope="col"
                        className="px-4 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider w-16 "
                      >
                        {statusLabel}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {availableDates?.map((detail, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-50 transition-colors"
                      >
                        <td className="px-4 py-3 text-sm text-gray-900">
                          {new Date(detail.date).toLocaleDateString(process.env.NEXT_PUBLIC_LANGUAGE === "en" ? "en-GB" : "tr-TR")}
                        </td>
                        {service.Type == "0" && (
                          <td className="px-4 py-3 text-sm text-gray-900 text-center">
                            {detail.price ? (
                              <DefaultCurrencyFormat
                                Symbol={symbol}
                                value={detail.price}
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                        )}
                        <td className="px-4 py-3 ">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                              detail.status === 1
                                ? "bg-green-100 text-green-800"
                                : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {detail.status === 1 ? statusAvailable : statusUnavailable}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {value == 0 ? (
                  <Warning>
                    {serviceFreePre} <strong>{serviceFreeStrong}</strong>{" "}
                    {serviceFreePost}
                  </Warning>
                ) : (
                  <Warning>
                    {servicePaidPre}{" "}
                    <strong>
                      {" "}
                      <DefaultCurrencyFormat
                        Symbol={symbol}
                        value={value}
                      />{" "}
                    </strong>
                    {servicePaidPost}
                  </Warning>
                )}
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </Modal>
    </div>
  );
};

export default ServiceRow;
